import { ref } from 'vue'
import { Locale } from '../enums/Locale'
import { useRoute } from 'vue-router'

export const isCNLocale = ref(process.env.VUE_APP_LANGUAGE === Locale.CHINESE)
